import { z } from 'zod';

export const BorderStyleSchema = z.enum(['solid', 'dashed', 'dotted']);

export type BorderStyle = z.infer<typeof BorderStyleSchema>;
